import { DeviceConfig, ProtocolMode } from 'shared/models';

export function getProtocolModeFromDeviceConfig(deviceConfig?: DeviceConfig | null): ProtocolMode {
    if (!deviceConfig?.properties?.params) {
        return ProtocolMode.COP;
    }

    const { displayConfiguration = 0 } = deviceConfig.properties.params;
    return displayConfiguration === 1 ? ProtocolMode.LIPLOP : ProtocolMode.COP;
}
